<template>
  <div class="create-keyword-attribute">
    <div v-if="selectedKeywordAttribute" class="create-keyword-attribute__title">Edit Attribute</div>
    <div v-else class="create-keyword-attribute__title">Create New Attribute</div>
     <label v-if="keywordAttribute.id" class="create-keyword-attribute__input">
       <span class="create-keyword-attribute__label">KW#: {{ selectedKeywordAttribute.keyword_count }}</span>
     </label>
     <label class="create-keyword-attribute__input">
      <span class="create-keyword-attribute__label">Active</span>
      <div class="create-keyword-attribute__link-wrapper" :class="{'create-keyword-attribute__link-wrapper_single': isDomainDropdownHidden}">
          <base-select
            border-less="true"
            class="create-keyword-attribute__active"
            :options="activeOpts"
            v-model="keywordAttribute.is_active"
            alignLeft="true"
            :max-height-list="450"
            :titleStyle="{ overflow: 'visible' }"
            :headerStyle="selectTypeStyle"
          />
      </div>
    </label>
    <label class="create-keyword-attribute__input">
      <span class="create-keyword-attribute__label">Name</span>
      <div class="create-keyword-attribute__link-wrapper" :class="{'create-keyword-attribute__link-wrapper_single': isDomainDropdownHidden}">
        <input type="text"
               class="form-control create-keyword-attribute__link-field"
               placeholder="Enter the Attribute Name"
               :class="{'form-control_error': externalErrors.name}"
               v-model="keywordAttribute.name">
        <span class="create-keyword-attribute__error-message" v-if="externalErrors.name">{{externalErrors.name}}</span>
      </div>
    </label>
    <label class="create-status__input">
      <span class="create-status__label">Inclusion List</span>
      <textarea
        class="list-text-area form-control create-keyword-attribute__link-field"
        rows="6"
        placeholder="Enter a newline-separated Inclusion List"
        v-model="keywordAttribute.inclusion_list">
      </textarea>
    </label>
    <label class="create-status__input">
      <span class="create-status__label">Exclusion List</span>
      <textarea
        class="list-text-area form-control create-keyword-attribute__link-field"
        rows="6"
        placeholder="Enter a newline-separated Exclusion List"
        v-model="keywordAttribute.exclusion_list">
      </textarea>
    </label>
    <div class="create-keyword-attribute__controls">
      <button class="create-keyword-attribute__button create-keyword-attribute__button_cancel"
              @click.prevent="close()">Close
      </button>
      <button v-if="selectedKeywordAttribute" class="create-keyword-attribute__button create-keyword-attribute__button_delete"
              @click.prevent="openConfirmModal">
        Delete
      </button>
      <button class="create-keyword-attribute__button create-keyword-attribute__button_submit"
              @click.prevent="apply()">
        Apply
      </button>
    </div>
    <div class="form-group">
      <hr />
      <h4>Examples</h4>
      <ul>
        <li>
          <strong>Phrase match (wrapped in double quotes):</strong>
          <ul>
            <li>
              <div>Input: "google search"</div>
              <ul>
                <li>Will Match: google search is the best</li>
                <li>Will Match: what is google search?</li>
                <li>Will Match: google search help</li>
                <li>Will NOT Match: google is the best search engine</li>
                <li>Will NOT Match: is googled a word or a search engine</li>
                <li>Will NOT Match: how to search with google</li>
              </ul>
            </li>
          </ul>

          <strong>Exact match (wrapped in square brackets):</strong>
          <ul>
            <li>
              <div>Input: [google search]</div>
              <ul>
                <li>Will ONLY Match: google search</li>
              </ul>
            </li>
          </ul>

          <strong>Broad match:</strong>
          <ul>
            <li>
              <div>Input: google search</div>
              <ul>
                <li>Will Match: google search is the best</li>
                <li>Will Match: what is google search?</li>
                <li>Will Match: google search help</li>
                <li>Will Match: google is the best search engine</li>
                <li>Will Match: is googled a word or a search engine</li>
                <li>Will NOT Match: how to search with google</li>
                <li>Will NOT Match: go oogle search</li>
              </ul>
            </li>
          </ul>

        </li>
      </ul>
    </div>
    <modal name="confirm-modal" v-bind="modalProps">
      <base-confirm-modal title="Are you sure you want to delete this?"
                          subtitle="This Keyword Attribute will be removed permanently!"
                          @confirm="confirmModal" />
    </modal>
  </div>
</template>

<script>
import _ from 'lodash'
import baseModalProps from '@/common/BaseModalProps'
import { mapActions } from 'vuex'
import BaseModalMixins from '@/common/BaseModalMixins'

const SELECT_STYLE = {
  'background-color': 'transparent',
  color: '#284aff',
  'text-decoration': 'underline'
}
const ACTIVE_OPTIONS = [
  {
    label: 'Yes',
    value: 1
  },
  {
    label: 'No',
    value: 0
  }
]
export default {
  name: 'CreateUpdateKeywordAttributePopup',
  mixins: [BaseModalMixins],
  props: {
    selectedKeywordAttribute: {
      type: Object,
      require: true
    }
  },
  data () {
    return {
      keywordAttribute: _.cloneDeep(this.selectedKeywordAttribute) || {
        name: '',
        is_active: 1,
        inclusion_list: '',
        exclusion_list: '',
        keyword_count: 0
      },
      externalErrors: {
        name: null
      },
      isDomainDropdownHidden: true,
      elementStyle: {},
      activeOpts: [...ACTIVE_OPTIONS],
      selectTypeStyle: { ...SELECT_STYLE }
    }
  },
  watch: {
    'keywordAttribute.name' (value) {
      this.keywordAttribute.name = value.trim().replace(/ +/g, '-').replace(/_+/g, '-')
    },
    selectedKeywordAttribute: {
      handler (newAttribute, oldAttribute) {
        this.keywordAttribute = _.cloneDeep(newAttribute) || {
          name: '',
          is_active: 1,
          inclusion_list: '',
          exclusion_list: '',
          keyword_count: 0
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    modalProps () {
      return { ...baseModalProps, height: 'auto', width: '510px' }
    }
  },
  methods: {
    ...mapActions('keywordAttributes', ['getKeywordCount']),
    close () {
      this.$emit('cancel')
    },
    showErrors (errors) {
      for (const k in this.externalErrors) {
        this.externalErrors[k] = null
      }

      for (const k in errors) {
        this.externalErrors[k] = errors[k]
      }
    },
    openConfirmModal () {
      this.$modal.show('confirm-modal')
    },
    confirmModal (status) {
      this.$modal.hide('confirm-modal')
      if (status) {
        this.deleteKeywordAttribute()
      }
    },
    apply () {
      this.$emit('apply', this.keywordAttribute)
    },
    deleteKeywordAttribute () {
      this.$emit('delete', this.keywordAttribute.id)
    }
  }
}
</script>

<style lang="scss">
  .create-keyword-attribute {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 40px;

    .v--modal-overlay {
      background-color: transparent !important;
    }

    &__title {
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      margin: 9px 0 35px;
      color: $rfx-dark-march;
    }

    &__input {
      display: flex;
      flex-direction: column;
      position: relative;
      margin-top: 30px;

      &_invalid[type='text'] {
        border: 1px solid $rfx-red;
        border-radius: 4px;
      }
    }

    &__label {
      display: block;
      font-weight: 600;
      margin-bottom: 5px;
      color: $rfx-dark-march;
    }

    &__controls {
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;
    }
    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_submit {
        background-color: $rfx-medium-march;
        color: #fff;

        &:disabled {
          pointer-events: none;
          background-color: #fff;
          color: $rfx-neutral-grey;
          cursor: default;
        }
      }

      &_delete {
        background-color: $rfx-medium-orange;
        color: #fff
      }

      &_disabled {
        pointer-events: none;
        background-color: #fff;
        color: $rfx-neutral-grey;
        cursor: default;
      }

      &_cancel {
        color: $rfx-dark-march;
        background-color: #fff;
      }
    }
    &__link {
      &-wrapper {
        position: relative;
        margin-top: 30px;

        &_single{
          margin-top: 0;
        }
      }

      &-field[type='text'] {
        width: 100%;
        box-sizing: border-box;
        padding-right: 60px;
        font-weight: 500;
        @include ellipsis;
      }
    }

    &__error-message {
        color: $rfx-red;
        font-size: 10px;
        margin-top: 5px;
      }

  }

  .form-control {
    height: 50px;
    padding: 0 20px;
    border: 2px solid $rfx-light-steel;
    outline: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    color: $rfx-dark-march;

    &::placeholder {
      color: $rfx-pearl;
      font-weight: normal;
      font-size: 14px;
    }

    &:disabled {
      background-color: $rfx-light-steel;
    }

    &_error{
       border-color: $rfx-red;
      color: $rfx-red;

       &::placeholder {
         color: $rfx-red;
         font-size: 13px;
       }

     }
  }

  .list-text-area {
    min-height: 100px;
    padding-top: 15px !important;
    resize: vertical;
    font-weight: 500 !important;
  }

</style>
